module.exports = __webpack_public_path__ + "img/Speaker=Wen L. Zhou.cfd25a8a.png";